import {Injectable, Type} from '@angular/core';
import {ModalOptionsConfig, ModalService} from '../../lean-shared/components/nz-modal-service/modal.service';
import {NzModalRef} from 'ng-zorro-antd/modal';
import {MONIEPOINT_DESIGN_TYPE} from '../../shared/constants';

@Injectable({
	providedIn: 'root'
})
export class ModalHelperService {
	runningModal: NzModalRef;
	readonly DEFAULT_MODAL_CLASSES = 'moniepoint-dialog kamona-modal-alert';
	// readonly DEFAULT_FULL_MODAL_CLASSES = 'kamona-full-screen-modal-alert';
	readonly DEFAULT_MODAL_WIDTH = 396;
	modalParameters: ModalOptions;

	constructor(private modal: ModalService) {
	}

	launchModal(modalParameters: ModalOptions) {
		const config = this.createModalConfig(modalParameters);
		this.runningModal = this.modal.createModal(
			modalParameters.component,
			config
		);
	}

	createModalConfig(modalParameters) {
		this.modalParameters = modalParameters;
		const config = new ModalOptionsConfig();
		config.nzWidth = modalParameters.width ? modalParameters.width : this.DEFAULT_MODAL_WIDTH;
		config.className = modalParameters.class ? modalParameters.class : this.DEFAULT_MODAL_CLASSES;
		config.nzComponentParams.data = modalParameters.params;
		config.nzComponentParams.callback = (result) => {
			this.handleOncloseModal(result);
		};
		return config;
	}

	handleOncloseModal(params) {
		if (this.modalParameters.callBack) {
			this.modalParameters.callBack(params);
		}
		try {
			this.runningModal.destroy();
		} catch {
		}
	}

	alert(modalOptions: ModalOptions) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = modalOptions?.alertType;
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.title = modalOptions?.title;
		config.className = this.DEFAULT_MODAL_CLASSES;
		if (modalOptions?.expiryTime) {
			config.nzComponentParams.expiryTime = new Date(`${modalOptions.expiryTime}`).getTime();
		}
		config.nzWidth = modalOptions?.width || this.DEFAULT_MODAL_WIDTH;
		config.nzCentered = true;
		if (modalOptions.callBack) {
			config.nzComponentParams.callback = modalOptions.callBack;

			// config.nzComponentParams.callback = () => {
			// 	modalOptions.callBack();
			// };
		}
		if (modalOptions.cancelCallback) {
			config.nzComponentParams.cancelCallback = () => {
				modalOptions.cancelCallback();
			};
		}
		config.nzComponentParams.cancelName = modalOptions?.cancelName;
		config.nzComponentParams.callbackName = modalOptions?.callbackName;
		config.nzComponentParams.message = modalOptions?.description;
		this.runningModal = this.modal.alert(config);
	}
}

export interface ModalOptions {
	component?: any;
	params?: any;
	width?: any;
	class?: any;
	callBack?: any;
	callbackName?: string;
	cancelName?: string;
	title?: string;
	description?: string;
	cancelCallback?: any;
	expiryTime?: any;
	fullScreen?: boolean;
	ref?: Type<any>;
	alertType?: 'success' | 'confirm' | 'error' | 'warning' | 'info';
}
